module.exports = __webpack_public_path__ + "img/review-fill.fb047b71.svg";